import React, { useEffect, useRef, useState } from "react";
import Header from "./../../Global/Header/Header";
import Footer from "./../../Global/Footer/Footer";
import classes from "./InfluencerRegistration.module.css";
import axios from "axios";
import RouteUrl from "../../RouteUrl";
import { useNavigate } from "react-router-dom";
import { Input } from "../../components/ui/input";

const InfluencerRegistration = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const influencerName = useRef(null);
  const instaId = useRef(null);
  const followersRange = useRef(null);
  const contactNumber = useRef(null);
  const emailId = useRef(null);
  const influencerCategory = useRef("000000");
  const resp1 = useRef(null);
  const resp2 = useRef(null);
  const resp3 = useRef(null);

  let [checked, setChecked] = useState(["", "", "", "", "", ""]);
  let followers = null;
  let checkUsed = 0;

  const checkHandler = (e, f) => {
    if (checked[e] == "") {
      checked[e] = f;
      checkUsed = 1;
    } else {
      checked[e] = "";
      checkUsed = 0;
    }
  };

  const submitHandler = async () => {
    if (
      !influencerName.current.value ||
      !instaId.current.value ||
      !contactNumber.current.value ||
      !resp1.current.value ||
      !resp2.current.value ||
      !resp3.current.value ||
      !checkUsed ||
      !followers
    ) {
      alert("Please fill the following details");
    } else {
      await axios
        .post(`${RouteUrl.Host}/influencer-registration`, {
          instaId: instaId.current.value,
          followers: followers,
          contactNumber: contactNumber.current.value,
          emailId: emailId.current.value,
          resp1: resp1.current.value,
          resp2: resp2.current.value,
          resp3: resp3.current.value,
          checked: checked,
        })
        .then((rs) => {
          // console.log(rs);
          navigate("/");
          alert("Form submitted");
        });
    }
  };

  return (
    <>
      <div className="relative bg-[#fad9d2] pt-[20vh] md:pt-0">
        <img
          className="w-full h-auto md:h-112 lg:h-full object-contain md:object-cover"
          src="https://static.wixstatic.com/media/dd0cc5_851c69675f094bfd9b6e6829982a071d~mv2.webp"
          alt=""
        />
        <div className="absolute top-0 left-0 right-0">
          <Header activeTab={""} />
        </div>
        <div className="ms-6 lg:ms-20 lg:w-2/3 absolute top-0 mt-28 lg:mt-36 left-0 right-0">
          <div className="flex flex-row">
            <p
              className={
                "font-Aeonik text-2xl lg:text-8xl text-orange-600 font-bold"
              }
            >
              Creator
            </p>
            <p
              className={
                "font-Aeonik text-2xl lg:text-8xl lg:ms-5 ms-2 text-black font-bold"
              }
            >
              Club !!
            </p>
          </div>
          <p className={"lg:text-3xl text-sm mt-8 lg:mt-10 me-20"}>
            🚀Mission - Provide revenue growth to the Creators
          </p>
          <p className={"lg:text-3xl text-sm mt-1 lg:mt-4 me-24"}>
            🔥 Largest Community of Influencers and Brands
          </p>
          <p className={"lg:text-3xl text-sm mt-1 lg:mt-4 me-28"}>
            💑 Curating personalized Travel Experience with India's best
            creators!
          </p>
        </div>
      </div>
      <div className="mt-2">
        <div className={`${classes["inf-rgstr-frm-container"]} border-[2px] border-inset `}>
          <p className={classes["form-heading"]}>Welcome to Influencers club</p>
          <p className={classes["question-text"]}>What's your name?</p>
          <Input
            ref={influencerName}
            type="text"
            className={"w-[90%] ml-[3vw]"}
            // className={classes["input-text"]}
          />
          <p className={classes["question-text"]}>
            What's your Instagram Id? {"(Please share your profile link)"}
          </p>
          <Input ref={instaId} type="text"
          className={"w-[90%] ml-[3vw]"}
          // className={classes["input-text"]}
           />
          <p className={classes["question-text"]}>Instagram Followers range:</p>
          <div className={classes["insta-follower-radio"]}>
            <label className={classes["follower-label"]}>
              <input
                onClick={() => {
                  followers = "Less than 10K";
                }}
                ref={followersRange}
                className={classes["insta-follower-options"]}
                type="radio"
                name="insta-follower-options"
                value="Less than 10K"
              ></input>
              Less than 10K
            </label>
            <label className={classes["follower-label"]}>
              <input
                onClick={() => {
                  followers = "10K-50K";
                }}
                ref={followersRange}
                className={classes["insta-follower-options"]}
                type="radio"
                name="insta-follower-options"
                value="10K-50K"
              ></input>
              10K-50K
            </label>
            <label className={classes["follower-label"]}>
              <input
                onClick={() => {
                  followers = "50K-100K";
                }}
                ref={followersRange}
                className={classes["insta-follower-options"]}
                type="radio"
                name="insta-follower-options"
                value="50K-100K"
              ></input>
              50K-100K
            </label>
            <label className={classes["follower-label"]}>
              <input
                onClick={() => {
                  followers = "Above 100K";
                }}
                ref={followersRange}
                className={classes["insta-follower-options"]}
                type="radio"
                name="insta-follower-options"
                value="Above 100K"
              ></input>
              Above 100K
            </label>
          </div>
          <p className={classes["question-text"]}>
            Please share your contact number:
          </p>
          <Input
            ref={contactNumber}
            type="text"
            className={"w-[90%] ml-[3vw]"}
            // className={classes["input-text"]}
          />
          <p className={classes["question-text"]}>
            Please share your Email Id:
          </p>
          <Input ref={emailId} type="text"
          className={"w-[90%] ml-[3vw]"}
          // className={classes["input-text"]} 
          />
          <p className={classes["question-text"]}>
            Select the following category:
          </p>
          <div className={classes["insta-checkbox"]}>
            <label className={classes["insta-label"]}>
              <input
                onClick={() => {
                  checkHandler(0, "Photographer");
                }}
                ref={influencerCategory}
                className={classes["insta-checkbx"]}
                type="checkbox"
                name="insta-checkbx"
                value="Photographer"
              />
              Photographer
            </label>
            <label className={classes["insta-label"]}>
              <input
                onClick={() => {
                  checkHandler(1, "Travel Influencer");
                }}
                ref={influencerCategory}
                className={classes["insta-checkbx"]}
                type="checkbox"
                name="insta-checkbx"
                value="Travel Influencer"
              />
              Travel Influencer
            </label>
            <label className={classes["insta-label"]}>
              <input
                onClick={() => {
                  checkHandler(2, "Videographer");
                }}
                ref={influencerCategory}
                className={classes["insta-checkbx"]}
                type="checkbox"
                name="insta-checkbx"
                value="Videographer"
              />
              Videographer
            </label>
            <label className={classes["insta-label"]}>
              <input
                onClick={() => {
                  checkHandler(3, "Fashion Blogger");
                }}
                ref={influencerCategory}
                className={classes["insta-checkbx"]}
                type="checkbox"
                name="insta-checkbx"
                value="Fashion Blogger"
              />
              Fashion Blogger
            </label>
            <label className={classes["insta-label"]}>
              <input
                onClick={() => {
                  checkHandler(4, "Content Creator");
                }}
                ref={influencerCategory}
                className={classes["insta-checkbx"]}
                type="checkbox"
                name="insta-checkbx"
                value="Content Creator"
              />
              Content Creator
            </label>
            <label className={classes["insta-label"]}>
              <input
                onClick={() => {
                  checkHandler(5, "Other");
                }}
                ref={influencerCategory}
                className={classes["insta-checkbx"]}
                type="checkbox"
                name="insta-checkbx"
                value="Other"
              />
              Other
            </label>
          </div>
          <p className={classes["question-text"]}>
            Where are you based out of?
          </p>
          <Input ref={resp1} type="text" 
          className={"w-[90%] ml-[3vw]"}
          // className={classes["input-text"]}
           />
          <p className={classes["question-text"]}>
            What are your expectations from us?
          </p>
          <Input ref={resp2} type="text" 
          className={"w-[90%] ml-[3vw]"}
          // className={classes["input-text"]}
           />
          <p className={classes["question-text"]}>Any message for us?</p>
          <Input ref={resp3} type="text" 
          className={"w-[90%] ml-[3vw]"}
          // className={classes["input-text"]}
           />
          <button onClick={submitHandler} className={classes["submit-button"]}>
            Submit
          </button>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default InfluencerRegistration;
